import React from 'react';

export const padTime = (value) => (value < 10 ? `0${value}` : `${value}`);

const DateTimeDisplay = ({ value, type, isDanger }) => {
  return (
    <div className={isDanger ? 'countdown__item danger' : 'countdown__item'}>
      <span className="countdown__value">{padTime(value)}</span>
      <span className="countdown__label">{type}</span>
    </div>
  );
};

export default DateTimeDisplay;
